import React from 'react';
import { useProductName } from 'App/helpers/productNames';

/** A Product field's value: the product's current name, or nothing once the product is gone. */
const ProductName = ({ value }: { value?: string | number | null }) => <>{useProductName(value)}</>;

export default ProductName;
